// File: Products.js
import api from './Axios';

export async function getAllProducts(page = 1, per_page = 100) {
  const response = await api.get(`/products`, {
    params: { page, per_page }
  });
  return response.data;
}